import script from "./MobileControlsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileControlsMenu.vue?vue&type=script&setup=true&lang=js"

import "./MobileControlsMenu.vue?vue&type=style&index=0&id=7153ac25&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7153ac25"]])

export default __exports__